module.exports = __webpack_public_path__ + "img/farzana-christopher-69.e059f40b.jpg";